<template>
    <div>
        <modal v-model="modal" class="skintestblock" :backdrop="false" size="lg">
            <h4 slot="title" class="smalltitle">Ticket for {{ detailTicket.event_title }}</h4>
            <div class="modal-body">
                <div class="event-single event-ticket">
                    <ul class="smalllist event-desc-list">
                        <li class="title">{{detailTicket.event_title}}</li>
                        <li>
                            <div><i class="fa fa-calendar-alt"></i></div>
                            <div>Start on <strong>{{formatFullTime(detailTicket.start_time)}}</strong> - End on
                                <strong>{{formatFullTime(detailTicket.end_time)}}</strong></div>
                        </li>
                        <li>
                            <div><i class="fa fa-map-marker-alt"></i></div>
                            <div>
                                <a href="#" title="View map">{{detailTicket.event_place}},
                                    {{detailTicket.event_street_number}}, {{detailTicket.event_city}}, {{detailTicket.event_state}}
                                    {{detailTicket.event_zipcode}}</a>
                            </div>
                        </li>
                        <li v-if="detailTicket.info_sponsor.company_name">
                            <strong>{{detailTicket.info_sponsor.company_name}}</strong>
                            <div style=" font-size: 13px; margin-left: 10px;">
                                <p style="font-style: italic; margin-bottom: 0px;">{{detailTicket.info_sponsor.services}}</p>
                                <p style="margin-bottom: 0px;">Address: <span>{{detailTicket.info_sponsor.street_number}}, {{detailTicket.info_sponsor.city}}, {{detailTicket.info_sponsor.state}} {{detailTicket.info_sponsor.zipcode}}</span></p>
                                <p style="margin-bottom: 0px;">Contact Name: <span>{{detailTicket.info_sponsor.contact_name}}</span></p>
                                <p style="margin-bottom: 0px;">Phone: <span>{{detailTicket.info_sponsor.phone_number}}</span></p>
                            </div>
                        </li>
                        <li v-if="detailTicket.sponsor_price">
                            <span>Sponsor Price</span>
                            <span style="float: right;">{{formatStringToView(detailTicket.sponsor_price)}}</span>
                        </li>
                        <li>
                            <span><strong>Exhibitors </strong></span>: <br>
                            <ul class="smalllist" style="border: none; font-size: 13px;">
                                <li v-for="exhibition in detailTicket.exhibitions" style="padding-right: 0px;">
                                    <div style="width: 100%;">
                                        <p><strong>{{exhibition.name}}</strong>, DOB {{exhibition.dob}}</p>
                                        <div style="width: 70%; float: left;">
                                            <p style="margin-left: 10px; margin-bottom: 0px;">Email: {{exhibition.email}}</p>
                                            <p style="margin-left: 10px; margin-bottom: 0px;">Work phone: {{exhibition.work_phone}}</p>
                                            <p style="margin-left: 10px; margin-bottom: 0px;">Cell phone: {{exhibition.cell_phone}}</p>
                                        </div>
                                        <div style="width: 30%; float: left; margin-top: -50px;">
                                            <img style="height: 115px; margin-left: 79px !important;" :src="'data:image/png;base64,' + exhibition.qr_code" alt="Ticket qrcode">
                                        </div>
                                        <p style="margin-left: 10px; margin-bottom: 0px;" v-if="exhibition.data_lodging && exhibition.data_lodging.hotel_name">
                                            Hotel: {{exhibition.data_lodging.hotel_name}}
                                            <span style="float: right">{{formatStringToView(exhibition.data_lodging.amount)}}</span>
                                        <p style="font-size: 12px; font-weight: normal; margin-left: 20px; margin-bottom: 0px;">
                                            {{exhibition.data_lodging.hotel_address}}</p>
                                        <span style="font-size: 13px; font-weight: normal; margin-left: 20px;" v-if="exhibition.data_lodging && exhibition.data_lodging.room_name">
                                                        Room: {{exhibition.data_lodging.room_name}}
                                                    </span>
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <span>Total</span>
                            <span style="float: right;">{{formatStringToView(detailTicket.total_price)}}</span>
                        </li>
                        <li class="ticket-barcode1"><img style="height: 60px !important;"
                                                         :src="'data:image/png;base64,' + detailTicket.bar_code_sponsor"
                                                         alt="Ticket barcode">
                            <div class="ticket-number"><span>{{detailTicket.code_sponsor}}</span></div>
                        </li>
                        <li class="ticket-barcode2"><img :src="'data:image/png;base64,' + detailTicket.qr_code_sponsor"
                                                         alt="Ticket qrcode">
                            <p class="smallexplain">Don't fold the barcodes' area. Second barcode maybe empty.</p></li>
                    </ul>
                </div>
            </div>

            <div slot="footer" class="chatformwrap">
                <button type="button" class="btn btn-default" @click.prevent="modal = false">Close</button>
            </div>
        </modal>
    </div>

</template>

<script>
import axios from '../../../client'
import Common from '../../mixins/Common'
import config from '../../../config'

const wikiUrl = config.wikiUrl
export default {
  name: 'DetailTicketSponsor',
  mixins: [Common],
  props: {
    detailTicket: { required: true }
  },
  data () {
    return {
      modal: false
    }
  },
  mounted () {
    this.modal = true
    console.log('detailTicket', this.detailTicket)
  },
  methods: {

  },
  beforeDestroy () {

  },
  updated () {},
  watch: {
    'modal' (newValue, oldValue) {
      this.$emit('updateModal', newValue)
    }

  }
}
</script>

<style scoped>

</style>
